/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/button-has-type */
import React from 'react';
import { useDispatch } from 'react-redux';
import deleteImg from '../assets/images/delete.svg';
import editImg from '../assets/images/edit.svg';
import { setEditForm, transactionRemove } from '../features/filter/filterTransactions';
import {
    editActive,
    removeFromAllTransactions,
    removeTransaction
} from '../features/transactions/transactionsSlice';
import numberWithCommas from '../utils/numberWithCommas';

function TransActionItem({ transaction }) {
    const dispatch = useDispatch();

    const handleRemove = () => {
        dispatch(transactionRemove(transaction.id));
        dispatch(removeTransaction(transaction.id));
        dispatch(removeFromAllTransactions(transaction.id));
    };

    const handleEdit = () => {
        dispatch(editActive(transaction));
        dispatch(setEditForm(true));
    };

    return (
        <li className={`transaction ${transaction.type === 'income' ? 'income' : 'expense'}`}>
            <p>{transaction.name}</p>

            <div className="right">
                <p>৳ {numberWithCommas(transaction.amount)}</p>
                <button className="link">
                    <img className="icon" src={editImg} alt="edit" onClick={handleEdit} />
                </button>
                <button className="link">
                    <img className="icon" src={deleteImg} alt="delete" onClick={handleRemove} />
                </button>
            </div>
        </li>
    );
}

export default TransActionItem;
